<template lang="pug">
layout(:title="$route.name" :rotas="rotas")
  Desktop(
    :local="local",
    :payment_sys_config="payment_sys_config" 
    :payment_menurocket_config="payment_menurocket_config", 
    :receipt="receipt"
    :report_taxes="report_taxes"
    :whatsapp_flow_templates="whatsapp_flow_templates"
    :saving_whatsapp_templates="saving_whatsapp_templates"
    @save-whatsapp-templates="saveWhatsappTemplates"
  )
  //- Desktop(:local="local",:payment_sys_config="payment_sys_config", :receipt="receipt",v-if="$vuetify.breakpoint.smAndUp")
  //- Mobile(:local="local" v-else)
</template>

<script>
import Desktop from "../components/Desktop/Index.vue";
// import Mobile from "../components/Mobile/Index.vue";
import { mapActions } from "vuex";
import { EventBus } from "@/main";

export default {
  components: {
    Desktop
    // Mobile
  },
  data() {
    return {
      local: {
        list_tables: []
      },
      payment_sys_config: {
        money: { active: true, tax_porcentage: 0 },
        card: { active: false, tax_porcentage: 0 },
        pix: { active: false, tax_porcentage: 0 },
        debit: { active: false, tax_porcentage: 0 },
        finishing: { active: false, tax_porcentage: 30 },
        custom_methods: []
      },
      payment_menurocket_config: {},
      receipt: {},
      report_taxes: [],
      whatsapp_flow_templates: {},
      saving_whatsapp_templates: false,
      rotas: [
        {
          name: "Início",
          path: "/dashboard"
        },
        {
          name: "Configurações",
          path: "/configurar-loja"
        }
      ]
    };
  },
  methods: {
    ...mapActions(["createGlobalMessage"]),
    syncLoggedTenant(changes = {}) {
      const user = this.$store.getters.getLoggedUser;
      if (!user || !user.tenant || !user.tenant.length) return;
      const tenant = { ...user.tenant[0], ...changes };
      const loggedUser = {
        ...user,
        tenant: [tenant, ...user.tenant.slice(1)],
        activeTenant: user.activeTenant && user.activeTenant._id === tenant._id
          ? tenant
          : user.activeTenant
      };
      this.$store.commit("setLoggedUser", loggedUser);
    },
    updateDarkShell() {
      if (localStorage.dark === "true") {
        document.body.classList.add("stonepro-config-dark");
      } else {
        document.body.classList.remove("stonepro-config-dark");
      }
    },
    normalizePaymentSysConfig(config = {}) {
      return {
        money: { tax_porcentage: 0, ...(config.money || {}), active: true },
        card: { active: false, tax_porcentage: 0, ...(config.card || {}) },
        pix: { active: false, tax_porcentage: 0, ...(config.pix || {}) },
        debit: { active: false, tax_porcentage: 0, ...(config.debit || {}) },
        finishing: { active: false, tax_porcentage: 30, ...(config.finishing || {}) },
        custom_methods: Array.isArray(config.custom_methods) ? config.custom_methods : []
      };
    },
    normalizeReportTaxes(reportTaxes = []) {
      return Array.isArray(reportTaxes)
        ? reportTaxes.map((tax, index) => ({
          id: tax.id || `report_tax_${index + 1}`,
          nome: tax.nome || tax.name || "Imposto",
          percentual: Number(tax.percentual || tax.percentage || 0),
          base: ["gross", "net"].includes(tax.base) ? tax.base : "gross",
          ativa: tax.ativa !== false
        }))
        : [];
    },
    saveLocal(data) {
      setTimeout(() => {
        this.$store.dispatch("enableLoading");
        this.$run("marketplaces/set-config-local", {
          local: data
        })
          .then(() => {
            this.$store.dispatch("disableLoading");
            this.local = data;
            this.syncLoggedTenant({ local: data });
            this.createGlobalMessage({
              timeout: 6000,
              type: "sucess",
              message: "Local salvo com sucesso!"
            });
          })
          .catch(e => {});
      }, 300);
    },
    savePaymentSysConfig(data) {
      setTimeout(() => {
        this.$store.dispatch("enableLoading");
        this.$run("marketplaces/set-config-payment-sys", {
          payment_sys_config: this.normalizePaymentSysConfig(data)
        })
          .then(res => {
            this.$store.dispatch("disableLoading");
            this.payment_sys_config = this.normalizePaymentSysConfig(
              res.data.payment_sys_config || data
            );
            this.syncLoggedTenant({ payment_sys_config: this.payment_sys_config });
            this.createGlobalMessage({
              timeout: 1000,
              type: "success",
              icon: "mdi-check-circle",
              message: "Formas de pagamento atualizadas 🚀"
            });
          })
          .catch(e => {});
      }, 300);
    },
    saveReceiptConfig(data) {
      setTimeout(() => {
        this.$store.dispatch("enableLoading");
        this.$run("marketplaces/set-config-receipt", {
          receipt: data
        })
          .then(() => {
            this.$store.dispatch("disableLoading");
            this.receipt = data;
            this.syncLoggedTenant({ receipt_config: data });
            this.createGlobalMessage({
              timeout: 6000,
              type: "success",
              message: "Os textos foram salvos 🚀"
            });
          })
          .catch(e => {});
      }, 300);
    },
    saveReportTaxes(data) {
      setTimeout(() => {
        this.$store.dispatch("enableLoading");
        this.$run("marketplaces/set-config-report-taxes", {
          report_taxes: this.normalizeReportTaxes(data)
        })
          .then(res => {
            this.$store.dispatch("disableLoading");
            this.report_taxes = this.normalizeReportTaxes(res.data.report_taxes || data);
            this.syncLoggedTenant({ report_taxes: this.report_taxes });
            this.createGlobalMessage({
              timeout: 2500,
              type: "success",
              icon: "mdi-check-circle",
              message: "Impostos de relatorio atualizados."
            });
          })
          .catch(e => {
            this.$store.dispatch("disableLoading");
            this.createGlobalMessage({
              timeout: 4000,
              type: "error",
              message: e?.response?.data?.message || "Nao foi possivel salvar os impostos."
            });
          });
      }, 300);
    },
    getLocal() {
      this.$store.dispatch("enableLoading");
      this.$run("marketplaces/get-config-local")
        .then(res => {
          this.$store.dispatch("disableLoading");
          this.local = res.data.local;
        })
        .catch(e => {});
    },
    getConfigPaymentSys() {
      this.$store.dispatch("enableLoading");
      this.$run("marketplaces/get-config-payment-sys")
        .then(res => {
          this.$store.dispatch("disableLoading");
          this.payment_sys_config = this.normalizePaymentSysConfig(res.data.payment_sys_config);
        })
        .catch(e => {});
    },
    getConfigPaymentMenurocket() {
      this.$store.dispatch("enableLoading");
      this.$run("marketplaces/get-config-payment-menurocket")
        .then(res => {
          this.$store.dispatch("disableLoading");
          this.payment_menurocket_config = res.data.payment_menurocket_config;
        })
        .catch(e => {});
    },
    getConfigReceipt() {
      this.$store.dispatch("enableLoading");
      this.$run("marketplaces/get-config-receipt")
        .then(res => {
          this.$store.dispatch("disableLoading");
          this.receipt = res.data.receipt;
        })
        .catch(e => {});
    },
    getConfigReportTaxes() {
      this.$run("marketplaces/get-config-report-taxes")
        .then(res => {
          this.report_taxes = this.normalizeReportTaxes(res.data.report_taxes);
        })
        .catch(e => {});
    },
    getWhatsappTemplates() {
      this.$run("marketplaces/get-config-whatsapp-templates")
        .then(res => {
          this.whatsapp_flow_templates = res.data.whatsapp_flow_templates || {};
        })
        .catch(e => {});
    },
    saveWhatsappTemplates(data) {
      this.saving_whatsapp_templates = true;
      this.$run("marketplaces/set-config-whatsapp-templates", {
        whatsapp_flow_templates: data
      })
        .then(res => {
          this.whatsapp_flow_templates = res.data.whatsapp_flow_templates || data;
          this.syncLoggedTenant({ whatsapp_flow_templates: this.whatsapp_flow_templates });
          this.createGlobalMessage({
            timeout: 2500,
            type: "success",
            icon: "mdi-check-circle",
            message: "Templates IntraWhats salvos."
          });
        })
        .catch(error => {
          this.createGlobalMessage({
            timeout: 4000,
            type: "error",
            message: error?.response?.data?.message || "Nao foi possivel salvar os templates."
          });
        })
        .finally(() => {
          this.saving_whatsapp_templates = false;
        });
    }
  },
  created() {
    this.updateDarkShell();
    this.getLocal();
    this.getConfigPaymentSys();
    this.getConfigPaymentMenurocket();
    this.getConfigReceipt();
    this.getConfigReportTaxes();
    this.getWhatsappTemplates();
    EventBus.$on("saveLocal", data => this.saveLocal(data));
    EventBus.$on("savePaymentSysConfig", data =>
      this.savePaymentSysConfig(data)
    );
    EventBus.$on("saveReceiptConfig", data => this.saveReceiptConfig(data));
    EventBus.$on("saveReportTaxes", data => this.saveReportTaxes(data));
    EventBus.$on("storeProfileUpdated", data => this.syncLoggedTenant(data));
  },
  mounted() {
    this.updateDarkShell();
  },
  beforeDestroy() {
    document.body.classList.remove("stonepro-config-dark");
  }
};
</script>

<style>
body.stonepro-config-dark,
body.stonepro-config-dark #app,
body.stonepro-config-dark .v-application,
body.stonepro-config-dark .v-application--wrap,
body.stonepro-config-dark main,
body.stonepro-config-dark .application--wrap,
body.stonepro-config-dark .v-content,
body.stonepro-config-dark .v-content__wrap,
body.stonepro-config-dark .v-main,
body.stonepro-config-dark .v-main__wrap,
body.stonepro-config-dark .container,
body.stonepro-config-dark .layout,
body.stonepro-config-dark .vitrify-content {
  background: #0b141a !important;
}
body.stonepro-config-dark .theme--light.v-tabs > .v-tabs-bar,
body.stonepro-config-dark .theme--light.v-tabs-items,
body.stonepro-config-dark .theme--light.v-window,
body.stonepro-config-dark .theme--light.v-card,
body.stonepro-config-dark .theme--light.v-sheet,
body.stonepro-config-dark .theme--light.v-list {
  background-color: #0b141a !important;
  color: #e9edef !important;
}
body.stonepro-config-dark .theme--light.v-tabs > .v-tabs-bar .v-tab,
body.stonepro-config-dark .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled),
body.stonepro-config-dark .theme--light.v-card,
body.stonepro-config-dark .theme--light.v-sheet,
body.stonepro-config-dark .theme--light.v-label,
body.stonepro-config-dark .theme--light.v-input input,
body.stonepro-config-dark .theme--light.v-input textarea,
body.stonepro-config-dark .v-list-item__title,
body.stonepro-config-dark .v-list-item__subtitle,
body.stonepro-config-dark .black--text,
body.stonepro-config-dark .fonte,
body.stonepro-config-dark h1,
body.stonepro-config-dark h2,
body.stonepro-config-dark h3,
body.stonepro-config-dark span {
  color: #e9edef !important;
}
body.stonepro-config-dark .grey--text,
body.stonepro-config-dark .v-messages,
body.stonepro-config-dark .v-label,
body.stonepro-config-dark input::placeholder,
body.stonepro-config-dark textarea::placeholder {
  color: #aebac1 !important;
}
body.stonepro-config-dark .v-input__slot,
body.stonepro-config-dark .v-text-field--filled > .v-input__control > .v-input__slot {
  background: #202c33 !important;
  color: #e9edef !important;
}
body.stonepro-config-dark .v-divider {
  border-color: #26343c !important;
}
body.stonepro-config-dark .v-icon {
  color: #aebac1 !important;
}
body.stonepro-config-dark .v-tabs-slider {
  background-color: #25D366 !important;
}
</style>
